import React from 'react'
import styled from 'styled-components'
//import { useTranslation } from 'gatsby-plugin-react-i18next'
import { MediaQueries as Mq } from '../styles/MediaQueries'

const StyledBar = styled.div`
  width: 100%;
  background-color: var(--paleBlue);
`

const Container = styled.div`
  max-width: var(--contentWidth);
  margin: 0 auto;
  padding: 2rem 4rem;
  ${Mq.sm} {
    padding: 2rem;
  }
  ul {
    list-style: unset;
    li {
      margin-left: 1rem;
    }
  }

  ol {
    margin-left: 1.4rem;
  }
`
const Note = styled.div`
  //display: inline-block;
  margin-bottom: 1rem;
`
const Notes = ({ content }) => {
  //const { t } = useTranslation()
  return (
    <StyledBar>
      <Container>
        <div>
          <Note
            dangerouslySetInnerHTML={{ __html: content.definitionNotesRt }}
          />
        </div>
        <div>
          <Note
            dangerouslySetInnerHTML={{ __html: content.measurementNotesRt }}
          />
        </div>
        <div>
          <Note
            dangerouslySetInnerHTML={{ __html: content.calculationNotesRt }}
          />
        </div>
        <div id="ds">
          <Note
            dangerouslySetInnerHTML={{ __html: content.dataSourceNotesRt }}
          />
        </div>
      </Container>
    </StyledBar>
  )
}

export default Notes
